import moment = require("moment");
import {Moment} from "moment";
import React = require("react");
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {TabButton, TabSelector} from "../../../../components/TabSelector";
import {I18n} from "../../../../components/Utils/i18n";
import "./CoffeeMachineDashboard.scss";
import {CoffeeMachineTablePage} from "./CoffeeMachineTablePage";
import {CoffeeMachineWidgetsPage} from "./CoffeeMachineWidgetsPage";
import "./reactDatepicker.scss";

import RangedDatePicker from "../../../../components/rangeddatepicker/RangedDatePicker";
import RangedDatePickerController from "../../../../components/rangeddatepicker/RangedDatePickerController";
import {MaintenanceForm} from "./components/maintenance/MaintenanceForm";
import {
    JSONDeleteMaintenancePopupTexts,
    JSONNewMaintenancePopupTexts
} from "./components/maintenance/NewMaintenanceInfoPopup";
import {Popup} from "./components/popup/Popup";
import {PopupController} from "./components/popup/PopupController";

export interface JSONWidgetTexts {
    title: string;
}

export interface JSONSWidgetWithLegendTexts extends JSONWidgetTexts {
    legendItems: string[];
}

export interface JSONContinueConsumptionsWidgetTexts extends JSONWidgetTexts {
    continueConsumptions: string;
    presetConsumptions: string;
    unknownConsumptions: string;
}

// tslint:disable-next-line:no-empty-interface
export interface JSONDispensingTimeAvgWidgetTexts extends JSONSWidgetWithLegendTexts {
}

// tslint:disable-next-line:no-empty-interface
export interface JSONDispensingPressureAvgWidgetTexts extends JSONWidgetTexts { }

export interface JSONWashesWidgetTexts extends JSONWidgetTexts {
    avgWashesByDay: string;
    purgePercentageByConsumption: string;
    washes: string;
    activeDayDescription: string;
    activeDays: string;
}

// tslint:disable-next-line:no-empty-interface
export interface JSONBoilerTemperatureAvgWidgetTexts extends JSONWidgetTexts { }

// tslint:disable-next-line:no-empty-interface
export interface JSONBoilerPressureAvgWidgetTexts extends JSONWidgetTexts { }

// tslint:disable-next-line:no-empty-interface
export interface JSONCoffeeWaterConsumptionWidgetTexts extends JSONWidgetTexts { }

// tslint:disable-next-line:no-empty-interface
export interface JSONFluxAvgWidgetTexts extends JSONWidgetTexts { }

export interface JSONTablePageTexts {
    consumptionsFrom: string;
    consumptionsTo: string;
    consumedCoffee: string;
    consumedWater: string;
    tableWidgetTitle: string;
    tableWidgetTitleExplanation: string;
    page: string;
    date: string;
    hour: string;
    dispensingGroup: string;
    dispensingTime: string;
    temperature: string;
    boilerTemperature: string;
    waterFlowSpeed: string;
    boilerPressure: string;
    pumpPressure: string;
    noDataAvailable: string;
    notDefined: string;
    allGroups: string;
    consumptionType: string;
    consumptionTypeContinue: string;
    consumptionTypePreset: string;
    consumptionTypeUnknown: string;
}

export interface JSONCoffeeMachineTexts {
    onlyContinueDispensingConsumptions: string;
    charts: string;
    table: string;
    parametersPageTitle: string;
    continueConsumptionsWidgetTexts: JSONContinueConsumptionsWidgetTexts;
    dispensingTimeAvgWidgetTexts: JSONDispensingTimeAvgWidgetTexts;
    dispensingPressureAvgWidgetTexts: JSONDispensingPressureAvgWidgetTexts;
    washesWidgetTexts: JSONWashesWidgetTexts;
    boilerTemperatureAvgWidgetTexts: JSONBoilerTemperatureAvgWidgetTexts;
    boilerPressureAvgWidgetTexts: JSONBoilerPressureAvgWidgetTexts;
    coffeeWaterConsumptionWidgetTexts: JSONCoffeeWaterConsumptionWidgetTexts;
    fluxAvgWidgetTexts: JSONFluxAvgWidgetTexts;
    tablePageTexts: JSONTablePageTexts;
    maintenanceWidgetTexts: JSONCoffeeMachineMaintenanceTexts;
    title: string;
    consumptionsFrom: string;
    consumptionsTo: string;
}

export interface JSONCoffeeMachineMaintenanceTexts {
    title: string;
    explanation: string;
    fromDate: string;
    sinceInstallation: string;
    days: string;
    kg: string;
    popupTexts: JSONNewMaintenancePopupTexts;
    deletePopupTexts: JSONDeleteMaintenancePopupTexts;
}

interface CoffeeMachineDashboardProps {
    equipmentGuid: string;
    texts: JSONCoffeeMachineTexts;
    totalCoffeeGroups: number;
    showSalesData: boolean;
}

interface CoffeeMachineDashboardState {
    activeTab: Tab;
    fromDate: Moment;
    toDate: Moment;
    toolBarHeight: number;
}

enum Tab {
    Current,
    History,
}

declare var LOCALE: string;

export const TOTAL_CONSUMPTIONS = 20;

export const DashboardPopupController: PopupController = new PopupController();

const toolbarStartHeight = 82;
const toolbarPadding = 39;
const headerHeight = 225;
const headerPadding = 10;

export class CoffeeMachineDashboard extends React.Component<CoffeeMachineDashboardProps, CoffeeMachineDashboardState> {

    private maxDate: Date = moment().endOf("day").toDate();
    private minDate: Date = moment()
        .endOf("day")
        .add(-179, "day")
        .toDate();

    private rangedDateController: RangedDatePickerController;

    private listener: Subscription;

    constructor(props) {
        super(props);
        this.onTabChange = this.onTabChange.bind(this);
        this.changeFromDate = this.changeFromDate.bind(this);

        this.rangedDateController = new RangedDatePickerController({
            startDate: moment().startOf("day").add(-14, "day").toDate(),
            endDate: moment().endOf("day").toDate(),
        });

        this.state = {
            activeTab: Tab.Current,
            fromDate: moment(this.rangedDateController.startDate),
            toDate: moment(this.rangedDateController.endDate),
            toolBarHeight: toolbarStartHeight,
        };
    }

    public componentDidMount() {

        $(window).resize(() => {
            const tabBar = $(".entityFunctionsOptionsContainer");
            this.setState({
                toolBarHeight: tabBar ? toolbarPadding + tabBar.height() : toolbarStartHeight,
            });
        });

        this.listener = this.rangedDateController.listen(({start, end}) => {
            this.setState({
                fromDate: moment(start),
                toDate: moment(end),
            });
        });
    }

    public componentWillUnmount() {
        if (this.listener) {
            this.listener.unsubscribe();
        }
    }

    public render() {
        let content;
        const tabBar = $(".entityFunctionsOptionsContainer");
        const tabTitle = (
            <div className="tab-title">
                <p>{this.props.texts.title}</p>
                <div className="data-picker-container">
                    <RangedDatePicker
                        controller={this.rangedDateController}
                        maxInterval={15}
                        fromLabel={this.props.texts.consumptionsFrom}
                        toLabel={this.props.texts.consumptionsTo}
                        minDate={this.minDate}
                        maxDate={this.maxDate}
                        dateFormat={I18n.getLocaleDateFormat(LOCALE)}
                        locale={LOCALE}
                        showBoth={false}
                        useETUIcomponent={true}
                    />
                </div>
            </div>
        );
        if (this.state.activeTab === Tab.Current) {
            content = (
                <CoffeeMachineWidgetsPage
                    equipmentGuid={this.props.equipmentGuid}
                    texts={this.props.texts}
                    dateRangeController={this.rangedDateController}
                />
            );
        } else {
            content = (
                <CoffeeMachineTablePage
                    equipmentGuid={this.props.equipmentGuid}
                    texts={this.props.texts.tablePageTexts}
                    fromDate={this.state.fromDate}
                    toDate={this.state.toDate}
                    totalCoffeeGroups={this.props.totalCoffeeGroups}
                    showSalesData={this.props.showSalesData}
                />
            );
        }
        const buttons: TabButton [] = [
            {key: Tab.Current, text: this.props.texts.charts},
            {key: Tab.History, text: this.props.texts.table},
        ];

        return (
            <div
                className="equipment-dashboard"
                style={{
                    height: "100%",
                }}
            >
                <div className="equipment-dashboard__header">
                    <div className="content">
                        <div className={"content-right"}>
                            <MaintenanceForm
                                machineGUID={this.props.equipmentGuid}
                                texts={this.props.texts.maintenanceWidgetTexts}
                                showRatios={false}
                            />
                        </div>
                        <div className={"content-left"}>
                            {tabTitle}
                            <TabSelector
                                buttons={buttons}
                                onSelect={this.onTabChange}
                                activeButtonKey={this.state.activeTab}
                                isSecondLevelTabbar={true}
                            />
                        </div>
                    </div>
                </div>
                <div style={{height: "calc(100% - " + headerHeight + "px)"}}>
                    {content}
                </div>
                <Popup
                    controller={DashboardPopupController}
                />
            </div>
        );
    }

    private changeFromDate(date) {
        this.setState({
                fromDate: moment(date).startOf("day"),
            },
        );
    }

    private onTabChange(tab: Tab) {
        if (this.state.activeTab !== tab) {
            this.setState({activeTab: tab});
        }
    }
}
